import { defineComponent as P, useSlots as $, useTemplateRef as N, ref as O, createElementBlock as c, createCommentVNode as i, openBlock as s, mergeProps as h, unref as l, createElementVNode as n, normalizeClass as t, createBlock as V, createSlots as A, withCtx as f, toDisplayString as k, createTextVNode as R, createVNode as b, renderSlot as x, h as y } from "vue";
import a from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Label/label-group.js";
import E from "../../node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Label/label.js";
import { CircleXmarkIcon as _ } from "../../packages/icons/dist/esm/icons/circle-xmark-icon.js";
import z from "./Label.vue2.js";
import D from "../Button.vue2.js";
import M from "../Tooltip/Tooltip.vue2.js";
import { findChildrenVNodes as U, fillTemplate as X } from "../../util.js";
import { useElementOverflow as j } from "../../use/index.js";
import { useOUIAProps as q } from "../../helpers/ouia.js";
const F = ["id"], H = { "aria-hidden": "true" }, J = ["aria-labelledby", "aria-label"], re = /* @__PURE__ */ P({
  name: "PfLabelGroup",
  __name: "LabelGroup",
  props: {
    id: {},
    defaultOpen: { type: Boolean },
    closable: { type: Boolean },
    compact: { type: Boolean },
    vertical: { type: Boolean },
    editable: { type: Boolean },
    editableTextarea: { type: Boolean },
    editableTextareaProps: {},
    category: {},
    numLabels: { default: 3 },
    tooltipPosition: { default: "top" },
    closeBtnAriaLabel: { default: "Close chip group" },
    ariaLabel: { default: "Chip group category" },
    expandedText: { default: "Show Less" },
    collapsedText: { default: "${remaining} more" },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["click", "overflow-chip-click"],
  setup(v, { emit: L }) {
    const o = v, C = q({ id: o.ouiaId, safe: o.ouiaSafe }), g = L, u = $(), T = N("labelRef"), B = j(T), p = O(o.defaultOpen);
    function G(e) {
      w(), g("overflow-chip-click", e);
    }
    function w() {
      p.value = !p.value;
    }
    function I() {
      const e = u.default ? U(u.default({})) : [], r = p.value ? e : e.slice(0, o.numLabels), d = r.map((m, S) => y("li", { key: S, class: a.labelGroupListItem }, m));
      if (e.length > o.numLabels) {
        const m = X(o.collapsedText, {
          remaining: e.length - r.length
        });
        d.push(y("li", { class: a.labelGroupListItem }, [
          y(
            z,
            {
              class: { [E.modifiers.compact]: o.compact },
              component: "button",
              overflow: !0,
              onClick: G
            },
            () => p.value ? o.expandedText : m
          )
        ]));
      }
      return d;
    }
    return (e, r) => e.$slots.default ? (s(), c("div", h({ key: 0 }, l(C), {
      id: e.id,
      class: [l(a).labelGroup, {
        [l(a).modifiers.category]: e.category,
        [l(a).modifiers.vertical]: e.vertical,
        [l(a).modifiers.editable]: e.editable
      }]
    }), [
      n("div", {
        class: t(l(a).labelGroupMain)
      }, [
        e.category ? (s(), V(M, { key: 0 }, A({
          default: f(() => [
            n("span", {
              ref: "labelRef",
              class: t(l(a).labelGroupLabel)
            }, [
              n("span", H, k(e.category), 1)
            ], 2)
          ]),
          _: 2
        }, [
          l(B) ? {
            name: "content",
            fn: f(() => [
              R(k(e.category), 1)
            ]),
            key: "0"
          } : void 0
        ]), 1024)) : i("", !0),
        n("ul", {
          class: t(l(a).labelGroupList),
          "aria-labelledby": e.id,
          "aria-label": e.ariaLabel,
          role: "list"
        }, [
          b(I),
          u["add-label-control"] ? (s(), c("li", {
            key: 0,
            class: t(l(a).labelGroupListItem)
          }, [
            x(e.$slots, "add-label-control")
          ], 2)) : i("", !0),
          e.editable && e.editableTextarea ? (s(), c("li", {
            key: 1,
            class: t([l(a).labelGroupListItem, l(a).modifiers.textarea])
          }, [
            n("textarea", h({
              class: l(a).labelGroupTextarea,
              rows: "1",
              tabindex: "0"
            }, e.editableTextareaProps), null, 16)
          ], 2)) : i("", !0)
        ], 10, J),
        e.closable ? (s(), c("div", {
          key: 1,
          class: t(l(a).labelGroupClose)
        }, [
          b(D, {
            variant: "plain",
            "no-padding": "",
            "aria-label": e.closeBtnAriaLabel,
            onClick: r[0] || (r[0] = (d) => g("click", d))
          }, {
            default: f(() => [
              b(l(_), { "aria-hidden": "" })
            ]),
            _: 1
          }, 8, ["aria-label"])
        ], 2)) : i("", !0)
      ], 2)
    ], 16, F)) : i("", !0);
  }
});
export {
  re as default
};
